module.exports = __webpack_public_path__ + "img/ogts_dillingen.0639357a.jpg";